import { initTabsBlock } from '../../src/js/tabs';
import { bootBlock } from '../../src/js/block-boot';

bootBlock('solutions-tabs', (root) => {
  initTabsBlock('.solutions-tabs', false, root);
});
